import { Component, Input } from '@angular/core';

@Component({
  selector: 'casa-doc-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrl: './alert-banner.component.scss',
  standalone: false,
})
export class AlertBannerComponent {
  @Input() type: 'WARNING' | 'INFO' = 'INFO';
  @Input() message: string = '';
}
